import findAllFor from '../filters/find-all-for';

const getAlignConstraintForElement = (element) => {
  const constraints = findAllFor(element);

  return constraints.find((constraint) => constraint.alignable);
};

export default getAlignConstraintForElement;
